export default __webpack_public_path__ + "static/media/umba.f29d152c.jpg";